import { render } from "./onWorkCard.vue?vue&type=template&id=7ae9038e&scoped=true&ts=true"
import script from "./onWorkCard.vue?vue&type=script&lang=ts"
export * from "./onWorkCard.vue?vue&type=script&lang=ts"

import "./onWorkCard.vue?vue&type=style&index=0&id=7ae9038e&lang=less&scoped=true"

import exportComponent from "/root/djmesweb-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ae9038e"]])

export default __exports__